/**
 * @copyright 2026 Cooltrax Pty Ltd. All rights reserved.
 */

// import { getZOrderColor } from '@/lib/map/GeofencesInView'

/** A geofence's display layer, shown as a numbered value. */
export const ZOrderPill = ({ zorder, size = 'sm' }: { zorder: number; size?: 'sm' | 'md' }) => (
  <span
    className={`inline-flex shrink-0 items-center justify-center rounded-full font-semibold text-base-content ${
      size === 'md' ? 'size-6 text-xs' : 'size-5 text-[11px]'
    }`}
    // style={{ backgroundColor: getZOrderColor(zorder) }}
    title={`Layer ${zorder}`}
    aria-label={`Layer ${zorder}`}
  >
    {zorder}
  </span>
)
